
// @ts-ignore
import {translate} from '@elements/translations';
import {defineComponent, reactive, watch, onMounted, ref} from 'vue';
import {getTicketTypeUrl} from "~vue/utils/urls.ts";
import {fetcher, assertData} from "~vue/utils/utils.ts";
import {TicketTypeStruct} from "~vue/utils/structs.ts";
import {useTicketStore} from '~vue/stores/TicketStore.ts';
import {useCalendarStore} from '~vue/stores/CalendarStore.ts';
import {storeToRefs} from 'pinia'
import Select from "~vue/components/form-elements/Select.vue";
import Error from "~vue/components/error/Error.vue";

export default defineComponent({
    name: 'TicketTypeView',
    components: {
        Error,
        Select
    },
    emits: ['isLoading'],
    setup(props, {emit}) {

        const ticketStore = useTicketStore();
        const {
            selectedTicketType,
            selectedRegion,
            selectedTicketSubType,
            type,
        } = storeToRefs(ticketStore);
        const {changeTicketSubType, resetTicketType, resetTicketSubType, changeHasCalendarView, changeHasDateListView, changeValidation, changeCatalogId, changeTicketName} = ticketStore;
        const calendarStore = useCalendarStore();
        const {resetShownCalendarMonth} = calendarStore;

        const ticketTypes = ref<String[]>([]);
        const ticketTypesOptions = ref<String[]>([]);
        const selectedTicketTypeDescription = ref<String>('');
        const selectedTicketSubTypeDescription = ref<String>('');
        const selectedSubTypes = reactive({
            title: '',
            types: [],
            options: []
        });
        const showError = ref<boolean>(false);
        const errorMessage = ref<String>('');

        const fetchTicketTypes = async () => {
            emit('isLoading', true);
            let url = getTicketTypeUrl(type.value, "?area=" + selectedRegion.value.id)
            await fetcher(url).then((result) => {
                if(result.success) {
                    assertData(result, TicketTypeStruct, url, 'fetchTicketTypes', 'danger');
                    ticketTypes.value = result.types;
                    ticketTypesOptions.value = ticketTypes.value.map((type) => {
                        return {
                            value: type.typeId,
                            label: type.name
                        }
                    })
                    showError.value = false;
                    errorMessage.value = '';
                    if(selectedTicketType.value !== "") {
                        prefillSubTypes();
                    }

                } else {
                    showError.value = true;
                    errorMessage.value = result.errorMessage;

                }
                emit('isLoading', false);
            }).catch((error) => {
                console.warn(error);
                showError.value = true;
                emit('isLoading', false);
            });
        }

        const prefillSubTypes = () => {
            selectedSubTypes.types = getSubTypes(selectedTicketType.value)?.types || [];
            selectedSubTypes.title = getSubTypes(selectedTicketType.value).title;
            selectedSubTypes.options = selectedSubTypes?.types ? selectedSubTypes.types.map((type) => {
                return {
                    value: type.ticketId,
                    label: type.name
                }
            }) : [];
            selectedTicketTypeDescription.value = getTypeItem(selectedTicketType.value)?.description || '';
            if(selectedSubTypes.types.length === 1) {
                changeTicketSubType(selectedSubTypes.types[0].ticketId);
                changeTicketName(selectedSubTypes.types[0].name);
            }
            if(selectedSubTypes.types.length === 0 || selectedTicketSubType.value !== "") {
                changeValidation('ticketType', true);
            } else {
                changeValidation('ticketType', false);
            }
        }

        watch(selectedTicketType, (value) => {
            resetTicketType();
            resetShownCalendarMonth();
            prefillSubTypes();
        });

        watch(selectedTicketSubType, (value) => {
            resetTicketSubType();
            resetShownCalendarMonth();
            selectedTicketSubTypeDescription.value = getSubType(value)?.description || '';
            changeCatalogId(getSubType(value)?.catalogueId);
            changeTicketName(getSubType(value)?.name);
            changeHasCalendarView(getSubType(value)?.hasCalendarView);
            changeHasDateListView(getSubType(value)?.hasDateListView);

            if(selectedSubTypes.types.length === 0 || selectedTicketSubType.value !== "") {
                changeValidation('ticketType', true);
            } else {
                changeValidation('ticketType', false);
            }
        });


        const getSubTypes =  <any>(id: String) => {
            return getTypeItem(id)?.subTypes || false;
        }

        const getTypeItem =  <any>(id: String) => {
            let selectedTypeItem = ticketTypes.value.find(item => item.typeId === id);
            return selectedTypeItem || false;
        }

        const getSubType =  <any>(id: String) => {
            let selectedTypeItem = selectedSubTypes.types.find(item => item.ticketId === id);
            return selectedTypeItem || false;
        }

        onMounted(() => {
            fetchTicketTypes();
        });

        return {
            ticketTypes,
            ticketTypesOptions,
            selectedTicketType,
            selectedSubTypes,
            selectedTicketSubType,
            selectedTicketSubTypeDescription,
            selectedTicketTypeDescription,
            showError,
            errorMessage,
            translate
        };
    }
});
